import { useEffect, useRef } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import {
  PROFILE_USER_INFO_ITEM_CLOSE_DELAY_MS,
  PROFILE_USER_INFO_ITEM_OPEN_DELAY_MS,
} from '../../ProfileUserInfoItem.constants'

export function useProfileUserInfoItemHover({
  hoverContainerRef,
  setOpen,
} = EMPTY_OBJECT) {
  const openTimeoutRef = useRef(null)
  const closeTimeoutRef = useRef(null)

  function clearOpenTimeout() {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current)
      openTimeoutRef.current = null
    }
  }

  function clearCloseTimeout() {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current)
      closeTimeoutRef.current = null
    }
  }

  function startOpenTimer() {
    clearOpenTimeout()
    clearCloseTimeout()

    openTimeoutRef.current = setTimeout(() => {
      setOpen(true)
    }, PROFILE_USER_INFO_ITEM_OPEN_DELAY_MS)
  }

  function handleMouseEnter() {
    startOpenTimer()
  }

  function handleMouseLeave() {
    clearOpenTimeout()
    clearCloseTimeout()

    closeTimeoutRef.current = setTimeout(() => {
      setOpen(false)
    }, PROFILE_USER_INFO_ITEM_CLOSE_DELAY_MS)
  }

  function handleIconMouseEnter() {
    clearOpenTimeout()
    clearCloseTimeout()
    setOpen(false)
  }

  function handleIconMouseLeave(event) {
    if (hoverContainerRef.current?.contains?.(event?.relatedTarget)) {
      startOpenTimer()
    }
  }

  useEffect(() => {
    return () => {
      clearOpenTimeout()
      clearCloseTimeout()
    }
  }, [clearCloseTimeout, clearOpenTimeout])

  return {
    handleIconMouseEnter,
    handleIconMouseLeave,
    handleMouseEnter,
    handleMouseLeave,
  }
}
